import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  aboutTitle: string;
  aboutContent: any;

  constructor(
    private _appService: AppService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

    this._appService.getConfigDataByPage('about').subscribe(res => {
      this.aboutTitle = res['conf_about_title']['config_val'];
      this.aboutContent = this.sanitizer.bypassSecurityTrustHtml(res['conf_about_content']['config_val']);
    });
  }

}
